import React from "react";
import actingImg from '../../assets/images/resources/about-one-img-1.jpg';

const VideoeditingMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://www.sunrisingcinevisionacademy.com/public/assets/images/video-editing-course.jpg" alt="Video Editing" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Become a Video Editing Expert with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy offers a comprehensive Video Editing course designed to equip aspiring editors with the skills to create professional, cinematic videos. Learn to use industry-standard software, master editing techniques, add visual effects, and craft compelling stories for films, ads, and social media. Our expert-led classes ensure you gain hands-on experience and creative confidence for a successful career in video production.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Editing fundamentals and storytelling techniques</li>
              <li>Professional software: Adobe Premiere Pro, Final Cut Pro, DaVinci Resolve</li>
              <li>Color grading, transitions, and visual effects</li>
              <li>Audio editing, sound design, and synchronization</li>
              <li>Exporting, formats, and workflow for different platforms</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Foundational Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Introduction to Video Editing</li>
              <li>Editing Theory & Storytelling</li>
              <li>Basic Cuts and Transitions</li>
              <li>Working with Footage & Timelines</li>
              <li>Introduction to Editing Software</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Intermediate Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Advanced Editing Techniques</li>
              <li>Color Correction & Grading</li>
              <li>Audio Editing & Sound Design</li>
              <li>Motion Graphics & Titles</li>
              <li>Multi-cam Editing</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Advanced Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Visual Effects Integration</li>
              <li>Editing for Film & TV</li>
              <li>Editing Documentaries & Ads</li>
              <li>Exporting & Delivery Formats</li>
              <li>Portfolio Development</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Specialized Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Social Media Video Editing</li>
              <li>Music Video Editing</li>
              <li>Wedding & Event Editing</li>
              <li>Corporate & Promotional Videos</li>
              <li>Freelancing & Industry Practices</li>
            </ol>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from Industry Experts</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Celebrity Editors:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>A. Sreekar Prasad</li>
                <li>Namrata Rao</li>
                <li>Rameshwar S. Bhagat</li>
                <li>Shweta Venkat Mathew</li>
                <li>Deepa Bhatia</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Mentors:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Rajkumar Hirani (Film Director & Editor)</li>
                <li>Shimit Amin</li>
                <li>Akiv Ali</li>
                <li>Antara Lahiri</li>
                <li>Hemanti Sarkar</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Guest Lecturers:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Resul Pookutty (Oscar-winning Sound Designer)</li>
                <li>Vikramaditya Motwane</li>
                <li>Neeraj Ghaywan</li>
                <li>Meghna Gulzar</li>
                <li>Other leading professionals</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Partnerships, Alumni, Certifications, Scholarships, Duration, Outcomes */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Yash Raj Films</li>
              <li>Dharma Productions</li>
              <li>Prime Focus</li>
              <li>Red Chillies Entertainment</li>
              <li>Balaji Telefilms</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Alumni Network</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Connect with successful editors in film, TV, and digital media.</li>
              <li>Participate in mentorship programs.</li>
              <li>Access job placement opportunities.</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certifications Offered</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Diploma in Video Editing</li>
              <li>Certificate in Video Editing</li>
              <li>Advanced Certificate in Video Editing</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Scholarship Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Merit-based scholarships</li>
              <li>Need-based scholarships</li>
              <li>Talent-based scholarships</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Course Duration</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certification Course in Video Editing – 4 months</li>
              <li>Certification Course in Video Editing – 6 months</li>
              <li>Diploma Course in Video Editing – 12 months</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Key Learning Outcomes</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Master professional video editing software and workflows.</li>
              <li>Create cinematic edits for films, ads, and social media.</li>
              <li>Apply color grading, audio editing, and visual effects.</li>
              <li>Develop a strong portfolio for industry opportunities.</li>
              <li>Gain hands-on experience with expert mentorship and real projects.</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Start Your Video Editing Journey Today!</h3>
          <p className="mb-6 text-gray-700">Enroll in the Video Editing course at Sunrising Cinevision Academy and take your first step toward becoming a professional video editor.</p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default VideoeditingMain;
